import classNames from 'classnames'
import React, { useEffect, useRef, useState } from 'react'
import IconDropDown from './icons/iconDropDown'

const CustomCheckBox = (
    {option=[], listSlect,setListeSelect, label, styleInput, placeholder}
) => {

    const [open, setOpen]=useState(false)
      const ref = useRef(null);

      const handleSelect=(event)=>{
        const value= event.target.value
        const isChecked= event.target.checked
        
            const newList= isChecked ?
            [...listSlect, value]
            : listSlect.filter((item)=>item!== value)
        
        setListeSelect(newList)
        
      }

      console.log(listSlect)

       useEffect(() => {
          const handleClickOutside = (e) => {
            if (ref.current && !ref.current.contains(e.target)) {
              setOpen(false);
              if(!listSlect){
                 setOpen(false)}
            }
          };
          document.addEventListener("mousedown", handleClickOutside);
          return () => document.removeEventListener("mousedown", handleClickOutside);
        }, []);
       
    
  return (
    <div ref={ref} className={classNames('relative ')}>

  {label && <label className="pl-2 mb-2 text-[#422EAE]  font-bold flex items-start">
    {label}
  </label>}

  <div
    onClick={() => setOpen(!open)}
    className={classNames(styleInput,'relative z-10 border border-[#AEB6FB]  rounded-[16px] text-[#D1D1FF] h-[48px] bg-white px-2 flex items-center justify-between cursor-pointer ')}
  >
   
    <div>{placeholder}</div>
    <IconDropDown   className={`transition-transform duration-200 ${open ? 'rotate-180 text-[#5754E5]' : 'text-[#AEB6FB]' }`}/>

  </div>
  {open &&(
     <div className={`  absolute z-[9999] left-0 w-full bg-white shadow-lg rounded-[6px]  max-h-[250px] overflow-auto `}>

        {option.map((item, index) =>(
            <div key={index} className={`h-[40px] flex items-center gap-2 pl-2 font-medium  text-[#35258B] hover:text-[#4D36CC] 
          }`}>
                <input className='cursor-pointer '
                type='checkbox'
                name='manipulation'
                id={`checkbox-${index}`}
                // id={index}
                checked={listSlect.includes(item)}
                value={item}
                onChange={handleSelect}
                />
                <label className='cursor-pointer' htmlFor={`checkbox-${index}`}>{item}</label>
            </div>
        ))}
    </div>)
    }
      
    </div>
  )
}

export default CustomCheckBox
